export const REDIS_READY_STATUS = 'ready';

export const DIMG_QUEUE_NAME = 'DIMG_QUEUE_NAME';
export const DIMG_PROCESSOR_NAME = 'DIMG_PROCESSOR_NAME';
export const QUEUE_CONFIG = 'QUEUE_CONFIG';
export const ADAP_INTAKE_QUEUE_CONFIG = 'ADAP_INTAKE_QUEUE_CONFIG';
export const EMAIL_QUEUE_CONFIG = 'EMAIL_QUEUE_CONFIG';

export const FIFTEEN_SEC_IN_MS = 1 * 15 * 1000;
